import qs from 'querystringify'

import {Base, NevoboResponse, Pagination} from "../base";
import {Poule, PouleIndeling} from "./types";

export class Poules extends Base {

    getPoule(poule: string): Promise<NevoboResponse<Poule>> {
        if (poule === "") {
            return this.getArgumentErrorPromise("Poule cannot be empty. If you want all poules, use getAllPoules() instead.")
        }
        return this.request<Poule>(`competitie/poules/${poule}`);
    }

    /**
     * @param team if team is not valid, this request returns the first page of getAllPoules()
     */
    getPoulesForTeam(team: string): Promise<NevoboResponse<Poule[]>> {
        if (team === "") {
            return this.getArgumentErrorPromise("Teams cannot be empty. If you want all poules, use getAllPoules() instead.")
        }
        return this.request<Poule[]>(`competitie/poules/?team=${team}`, true);
    }


    /**
     * Poules requires pagination, the limit per page is 1000
     * @param pagination
     */
    getAllPoules(pagination: Pagination): Promise<NevoboResponse<Poule[]>> {
        const endpoint = `competitie/poules/` + qs.stringify(pagination, '?');
        return this.request<Poule[]>(endpoint, true);
    }

    /**
     * Get the standings of all teams in a Poule.
     * I don't know why they named it like this.
     * @param poule
     */
    getPouleIndelingen(poule: string): Promise<NevoboResponse<PouleIndeling[]>> {
        if (poule === "") {
            return this.getArgumentErrorPromise("Poule cannot be empty.")
        }
        const endpoint = `competitie/pouleindelingen/?poule=${poule}`;
        return this.request<PouleIndeling[]>(endpoint, true);
    }

}
